import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../function/config";
import axios from "axios";
import HomeNav from "./Navbars/HomeNav";
import Footer from "./Footer";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { toast } from "react-toastify";

export default function SingleShipCharter() {
  const [obj, setObj] = useState({});

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenS, setIsOpenS] = useState(true);

  const [isScrolled, setIsScrolled] = useState(false);

   const { id } = useParams();

  useLayoutEffect(() => {
  window.scrollTo(0, 0);
}, [id]);

 

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleCharter/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setObj(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const [Amenities,setAmenities] = useState([])

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleAmenity/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setAmenities(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);



  const [thumbnailImage, setThumbnailImage] = useState("");
  const [mainImages, setMainImages] = useState([]); // Store multiple images

  useEffect(() => {
    async function fetchShipImages() {
      try {
        const response = await axios.get(`${config.base_url}/api/HappyMarineShipping/singleShipImageCReg/${id}`);

        if (response.data.status === 200 && response.data.data.length > 0) {
          console.log("Fetched Images Data:", response.data.data);

          // Extract all main images
          const mainImagesData = response.data.data.filter(img => img.image !== null).map(img => img.image);
          setMainImages(mainImagesData);

          console.log("Main Images Array:", mainImagesData);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }

    fetchShipImages();
  }, [id]);


  const [isOpenModal, setIsOpenModal] = useState(false);        // for dropdown
const [showModal, setShowModal] = useState(false);  // for enquiry modal
const [Name,setName] = useState('')
const [Email,setEmail] = useState('')
const [Mobile,setMobile] = useState('')
const [Subject,setSubject] = useState('')
const [loading,setLoading] =useState(false)
const [count,setCount] = useState(1)

  const EnquirySubmit = async(e)=>{
    e.preventDefault();
    setLoading(true)
    const formData = new FormData();
      formData.append("name", Name);
      formData.append("email", Email);
      formData.append("mobile", Mobile);
      formData.append("subject", Subject);
          
    try {
                  
                    const response = await axios.post(`${config.base_url}/api/HappyMarineShipping/add_enquiry`,formData,{
                      headers:{
                        'Content-Type':'multipart/form-data',
                      }
                    });
                    if(response.data.status===200){
                     
                      console.log(response)
                      setLoading(false)
                      setShowModal(false)
                      toast.success("Sent Successfully!",{
                        autoClose:1500,
                        position:'top-right',
                        
                      });
                      setCount(id)
                     
                     
                      
                    }
                    else{
                        setLoading(false)
                      console.log("error1")
                      toast.error("Fill the required Fields",{
                        autoClose:1500,
                        position: "top-right",
                      })
                    }
                    
                  } catch (err) {
                    setLoading(false)
                    console.log("error2",err)
                    toast.error("Error",{
                      autoClose:2000,
                      position: "top-right",
                    })
                  }

  }


  const [allShips, setallShips] = useState([]);
    const [allShipsReg, setallShipsReg] = useState([]);
  
   
    // Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForCharter`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res1.data.status === 200) {
          console.log(res1)
          setallShips(res1.data.data.reverse())
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  
  
  
  
  
    
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
  
  const [allImages,setallImages] = useState([])
   
    
   useEffect(() => {
  async function fetchdata() {
    try {
      const res3 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/ship_images_CReg`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res3.data.status === 200) {
        console.log("All Images Fetched:", res3.data.data); // ✅ Add this line
        setallImages(res3.data.data);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [config.base_url, count]);


   
  function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const similarShips = shuffleArray(
  allShips
);


  const [selectedImage, setSelectedImage] = useState(null);
  
  // Add this above your return block or inside the component
  const handleCloseModal = () => setSelectedImage(null);
  




  return (
    <div className="bg-gradient-to-r from-[#2e5775] to-[#326e99]">
      <HomeNav />
      <div className="px-10 lg:hidden mt-5">
      <button className="text-white" onClick={() => navigate(`/ship-chartering`)}>
      <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
      </button>
        </div>
      <div className="hidden lg:block p-5 px-10  bg-white">
        <div className="flex justify-between flex-wrap gap-3">
          <h1 className="text-[#d1a460] text-xl font-bold">Ship Details</h1>
          <div>
            <Link to={"/"} className="text-xl text-[#d1a460]">
              Home /{" "}
            </Link>
            <Link to={"/"} className="text-xl text-[#d1a460]">
              {" "}
              Categories /
            </Link>
          </div>
        </div>
      </div>

      <div className="px-10 xm:px-2 lg:block hidden mt-5">
      <button className="text-white" onClick={() => navigate(`/ship-chartering`)}>
      <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
      </button>
        </div>

       <div className="flex gap-5   2xl:block  xm:p-3 mt-[20px] mb-10 px-10">
                     
                     {/* 2nd div description */}
                     <div className="w-[70%] 2xl:w-[100%] h-full 2xl:mt-5 border rounded    border-gray-400 bg-[#123d5f] flex flex-col ">
                       <div className=" rounded-t ">
                               <div className="text-gray-200 ">
                                 <div className="px-3 py-3">
                                   <div
                                     className="flex flex-wrap justify-between xm:text-lg xm:px-2 items-center rounded bg-[#d1a460] py-3 text-white font-bold text-xl px-4 cursor-pointer"
                                    
                                   > 
                                     <h1 className="">Short Descriptions</h1>
                                     {obj.open_area && (
                                               <div className=" ">
                                                 <span className="font-semibold  ">
                                                   Open Area : 
                                                 </span>
                                                 <span className="text-white ml-2">
                                                    {obj.open_area}
                                                 </span>
                                               </div>
                                             )}
                                     <h1 className=""> Ref : {obj.ship_code} - {id}</h1>
             
                                   </div>
                                 </div>
             
                                 
                                  <div className="flex justify-between py-3 md:flex-wrap-reverse px-3 w-[100%]">
                                     <div className="px-3 py-3 w-[90%] h-full">
                                       
                                          {/* LOA and Built Year */}
                                         {(obj.vessel_type || obj.open_area) && (
                                          
                                           <div className="">
                                            {obj.vessel_type && (
                                               <div className="w-full">
                                                 <span className="font-semibold  ">
                                                   vessel_type:
                                                 </span>
                                                 <span className="text-[#d1a460] ml-3">{obj.vessel_type}</span>
                                               </div>
                                             )}
                                           </div>
                                         )}
                                         {/* Flag and Capacity */}
                                         {(obj.tc_vc || obj.capacity) && (
                                           <div className=" ">
                                             {obj.tc_vc && (
                                               <div className="w-full mt-3">
                                                 <span className="font-semibold  ">
                                                 TC/VC:
                                                 </span>
                                                 <span className="text-[#d1a460] ml-[60px]">
                                                   {obj.tc_vc}
                                                 </span>
                                               </div>
                                             )}

                                             {obj.DWT && (
                                               <div className="w-full mt-3">
                                                 <span className="font-semibold  ">
                                                 Capacity:
                                                 </span>
                                                 <span className="text-[#d1a460] ml-[40px]">
                                                   {obj.DWT}
                                                 </span>
                                               </div>
                                             )}
                                             
                                           </div>
                                         )}
                       
                                         {/* <div className="w-full mt-5">
                                           <span
                                             onClick={() => navigate(`/shipLoc/${obj.id}`)}
                                             className=" text-blue-400 cursor-pointer hover:underline "
                                           >
                                             Track Location
                                           </span>
                                         </div> */}

                             <div className=" mt-4 border-t border-gray-100">
                              <h1 className="mt-5 font-bold">More Infromations :</h1>
                         <div className="relative p-3  text-base text-[#d1a460]">
                       <div className="pr-32 ">
                         {obj.brief_description ? (
                           obj.brief_description.split("\n").map((detail, index) => {
                             const urlRegex = /(https?:\/\/[^\s]+)/g;
                             const parts = detail.split(urlRegex);
       
                             return (
                               <p key={index} className="mb-2 break-words whitespace-pre-wrap">
         {parts.map((part, i) =>
           urlRegex.test(part) ? (
             <a
               key={i}
               href={part}
               target="_blank"
               rel="noopener noreferrer"
               className="text-blue-600 underline hover:text-blue-800 break-words"
             >
               {part}
             </a>
           ) : (
             <span key={i}>{part}</span>
           )
         )}
       </p>
       
                             );
                           })
                         ) : (
                           <p className="text-red-500">No description available</p>
                         )}
                       </div>
       
                       {/* Enquiry Button */}
                       <button
                         onClick={() => setShowModal(true)}
                         className="absolute bottom-3 right-3 text-black bg-gray-50 border border-[#a1ccec] hover:bg-green-500 hover:text-white rounded-md px-3 py-2 shadow-lg hover:shadow-xl transition"
                       >
                         Send Enquiry
                       </button>
                     </div>
                         </div>
                                   </div>
                                   
             
                                 {mainImages.length > 0 && (
                                  <div className="w-[500px] h-[200px] md:m-auto xm:w-full bg-[#123d5f] border p-2 border-gray-400">
  <div className="w-full h-full relative cursor-pointer">
    {mainImages.length > 0 ? (
      <>
        <img
          src={mainImages[0]}
          className="w-full h-full xm:w-full "
          alt="Ship Image"
          onClick={() => setSelectedImage(mainImages[0])}
        />
        {/* Hover Overlay */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300"
        >
          <span className="text-white text-sm font-semibold underline">
            Click here to view image
          </span>
        </div>

        {/* Enlarge Icon */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute bottom-2 right-2 bg-black bg-opacity-60 px-3 py-2 rounded-full hover:bg-opacity-90 transition"
          title="Click to enlarge"
        >
          <i class="fa-solid fa-up-right-and-down-left-from-center  text-white"></i>
        </div>
      </>
    ) : !thumbnailImage ? (
      <img
        src="fallback.jpg"
        className="w-full h-full"
        alt="No Image Available"
      />
    ) : null}
  </div>
</div>)}
             
                                  </div>
                               </div>
                               
                             </div>
                             {selectedImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
    onClick={handleCloseModal}
  >
    <div
      className="w-[1000px] h-[600px] xm:w-[500px] xm:h-[300px] overflow-auto"
      onClick={(e) => e.stopPropagation()}
    >
      
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        initialSlide={mainImages.findIndex((img) => img === selectedImage)}
        className="w-full h-full"
      >
        
        {mainImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div
          onClick={handleCloseModal}
          className="absolute top-2 right-2 cursor-pointer bg-opacity-60 px-4 py-2 rounded-full hover:bg-opacity-90 transition"
        >
          <h1 className="text-red-600 font-bold text-2xl ">X</h1>
        </div>
            <img
              src={image}
              onClick={handleCloseModal}
              alt={`Enlarged ${index}`}
              className="rounded-lg w-full h-full m-auto"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
)}
             
                    
             
                       {/* 🟦 Modal */}
                       {showModal && (
                         <div className="fixed inset-0 bg-black bg-opacity-50 xm:px-3 flex justify-center items-center z-50">
                           <div className="bg-white w-[650px] xm:w-auto xl:max-w-md rounded-lg shadow-lg relative">
                             <div className="bg-[#123d5f] px-6 py-3 flex justify-between">
                               {" "}
                               <h2 className="text-2xl font-bold   text-white">
                                 Enquiry Form
                               </h2>
                               <button
                                 onClick={() => setShowModal(false)}
                                 className="text-2xl font-bold   text-red-500"
                               >
                                 X
                               </button>
                             </div>
                             <form className="space-y-4 p-6">
                               <div>
                                 <label
                                   htmlFor="name"
                                   className="block text-sm font-medium text-gray-700"
                                 >
                                   Your Name/Company Name
                                 </label>
                                 <input
                                   id="name"
                                   type="text"
                                   placeholder="Name"
                                   value={Name}
                                   onChange={(e) => setName(e.target.value)}
                                   className="w-full border border-gray-300 rounded px-4 py-2"
                                 />
                               </div>
             
                               <div className="flex gap-4 xl:flex-wrap xl:gap-0 items-center">
                                 <div className="w-full">
                                   <label
                                     htmlFor="email"
                                     className="block text-sm font-medium text-gray-700"
                                   >
                                     Email
                                   </label>
                                   <input
                                     id="email"
                                     type="email"
                                     placeholder="Email"
                                     value={Email}
                                     onChange={(e) => setEmail(e.target.value)}
                                     className="w-full border border-gray-300 rounded px-4 py-2"
                                   />
                                 </div>
                                 <div className="w-full">
                                   <label
                                     htmlFor="mobile"
                                     className="block text-sm font-medium text-gray-700"
                                   >
                                     Mobile
                                   </label>
                                   <input
                                     id="mobile"
                                     type="tel"
                                     placeholder="Mobile"
                                     value={Mobile}
                                     onChange={(e) => setMobile(e.target.value)}
                                     className="w-full border border-gray-300 rounded px-4 py-2"
                                   />
                                 </div>
                               </div>
             
                               <div>
                                 <label
                                   htmlFor="subject"
                                   className="block text-sm font-medium text-gray-700"
                                 >
                                   Subject
                                 </label>
                                 <textarea
                                   id="subject"
                                   placeholder="Subject"
                                   value={Subject}
                                   onChange={(e) => setSubject(e.target.value)}
                                   className="w-full border border-gray-300 rounded px-4 py-2"
                                 />
                               </div>
             
                               <div className="flex justify-end gap-2">
                                 <button
                                   type="button"
                                   onClick={() => setShowModal(false)}
                                   className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                                 >
                                   Cancel
                                 </button>
                                 <button
                                   type="submit"
                                   onClick={(e) => EnquirySubmit(e)}
                                   className="bg-[#123d5f] text-white px-4 py-2 rounded hover:bg-[#0f2e48]"
                                 >
                                   {loading ? (
                                     <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                                   ) : (
                                     "Submit"
                                   )}
                                 </button>
                               </div>
                             </form>
                           </div>
                         </div>
                       )}

                       <div className="px-5">
                         
                       </div>
                       </div>
             
                     
                     
             
                     {/*3rd similar ships */}
                     <div className="w-[25%] 2xl:w-[100%] 2xl:mt-5 h-full overflow-y-auto border bg-[#123d5f] border-gray-400 rounded  p-2">
               <h2 className="text-white text-lg font-semibold mb-2">Similar Ships For Charter</h2>
               {similarShips.length > 0 ? (
  similarShips.slice(0, 3).map((ship) => {
    const shipImageObj = allImages.find(
      (img) => img.charter === ship.id && img.image !== null
    );

    const imageUrl = shipImageObj?.image;

    return (
      <div
        onClick={() => {
          navigate(`/singleShipCharter/${ship.id}`);
          window.location.reload();
        }}
        key={ship.id}
        className="bg-[#d1a460] mb-3 cursor-pointer p-2 rounded shadow"
      >
        <div className="flex justify-between">
          <p className="text-sm text-white">Vessel Type: {ship.vessel_type}</p>
          <p className="text-sm text-white">DWT: {ship.DWT}</p>
          </div>
        <p className="text-sm mt-1 text-white">Open Area: {ship.open_area}</p>

        {imageUrl && (
          <img
            src={imageUrl}
            className="w-full h-24 rounded mt-1 "
            alt="Ship"
          />
        )}
      </div>
    );
  })
) : (
  <p className="text-gray-200">No similar ships found</p>
)}


             </div>
             
                   </div>

      <Footer />
    </div>
  );
}